import React, { useCallback, useContext } from 'react'
import { CrossIcon, Divider } from 'chemistry'
import classNames from 'classnames'
import { TranslateContext } from '../../../../common/translator'
import { isPraxis, isBrico } from 'common/utils'

const bricoLangMapping = {
  nl_BE: 'nl',
  fr_BE: 'fr',
  fr: 'fr',
  nl: 'nl'
}

const SidePanel = ({ sidePanelToggled, setSidePanelToggled, disabled, format, lang }) => {
  const toggleSidePanel = useCallback(() => {
    setSidePanelToggled(false)
  }, [setSidePanelToggled])

  const closeSidePanel = useCallback(() => {
    toggleSidePanel()
  }, [toggleSidePanel])

  const t = useContext(TranslateContext)

  return (
    <>
      <div onClick={closeSidePanel} data-toggle-active={sidePanelToggled} className='mxd-pdp-layout-background' />
      <div
        data-toggle-active={sidePanelToggled}
        className={classNames(
          {
            'mxd-disabled': disabled
          },
          'mxd-pdp-layout-side-panel'
        )}
        inert={!sidePanelToggled ? '' : undefined}
      >
        <div className={'mxd-pdp-layout'}>
          <header className='flex justify-between items-center'>
            <div className='mxd-pdp-layout-header'>{t('own_brand_header_text')}</div>
            <button onClick={closeSidePanel}>
              <CrossIcon />
            </button>
          </header>
          <Divider mb='32px' mt='24px' />
          <div className='mxd-pdp-layout-hero'>
            {isPraxis(format) && <div className='mxd-pdp-layout-hero-image-praxis'></div>}
            {isBrico(format) && <div className={`mxd-pdp-layout-hero-image-brico-${bricoLangMapping[lang]}`}></div>}
            <div className='mxd-pdp-layout-hero-text'>{t('own_brand_hero_text')}</div>
          </div>
          {sidePanelToggled && (
            <div className='mxd-pdp-layout-main-content' dangerouslySetInnerHTML={{ __html: t('own_brand_content') }} />
          )}
        </div>
      </div>
    </>
  )
}

export default SidePanel
